import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sso")({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<div className="h-full relative flex flex-col items-center justify-normal">
			<Outlet />
		</div>
	);
}
